
const ndash = '–';
//const mdash = '—';

/**
 * @param Date[] dates 
 * @returns String
 */
export default function(dates) {
    const month1 = (new Intl.DateTimeFormat('en', {month: 'long'})).format(dates[0]);
    const year1 = dates[0].getFullYear();
    const day1 = dates[0].getDate();
    const date1StartsMonth = day1 === 1;
    const date1Parts = [];

    if (dates.length === 1) {
        date1Parts.push(month1);
         if (! date1StartsMonth) date1Parts.push(day1);
         date1Parts.push(year1);
         return date1Parts.join(' ');
    }

    const month2 = (new Intl.DateTimeFormat('en', {month: 'long'})).format(dates[1]);
    const year2 = dates[1].getFullYear();
    const day2 = dates[1].getDate();
    const date2EndsMonth = false; // || day2; // todo
    const date2Parts = [];

    date1Parts.push(month1);
    if (! date1StartsMonth || ! date2EndsMonth) {
        date1Parts.push(day1);
    }
    if (year1 != year2) {
        date1Parts.push(year1);
    }
    if (month1 != month2 || year1 != year2) {
        date2Parts.push(month2);
    }
    if (! date1StartsMonth || ! date2EndsMonth) {
        date2Parts.push(day2);
    }

    if (date2Parts.length) {
        date2Parts.push(year2);
    } else {
        date1Parts.push(year1);
    }
    
    return date1Parts.join(' ') + ndash + date2Parts.join(' ');
}
